<template>
<v-container id="members" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">

    <div class="mt-8 px-5 py-5 elevation-6 rounded">
      <div class="d-flex justify-space-between">
        <div class="d-flex action">
          <!-- <v-sheet
          color="primary "
          elevation="6"
          class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
          dark
          :max-width="65"
          @click="vue='voir',init()"
          style="cursor: pointer"
          >
            <v-icon size="32">mdi-clipboard-text</v-icon>
            <span class="text-caption text-uppercase">Voir</span>
          </v-sheet>  -->
          <v-sheet
            color="primary "
            elevation="6"
            class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
            dark
            :max-width="65"
            @click="vue='creer',getSaison(),init()"
            style="cursor: pointer"
          >
            <v-icon size="32">mdi-pencil</v-icon>
            <span class="text-caption text-uppercase">Attribuer</span>
          </v-sheet>
          <v-sheet
          v-if="['1'].includes($store.state.currentUser.user.autorisation)"
          color="primary "
          elevation="6"
          class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
          dark
          :max-width="65"
          @click="vue='suivre',getSaison(),init()"
          style="cursor: pointer"
          >
            <v-icon size="32">mdi-clipboard-text</v-icon>
            <span class="text-caption text-uppercase">Suivre</span>
          </v-sheet> 
        </div>
        <div class="d-flex save">
          <!-- <v-sheet
            :color="trash.save?'red':'grey'"
            elevation="6"
            class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
            dark
            :max-width="65"
            @click="supprimer()"
            style="cursor: pointer"
          >
            <v-icon  size="32">mdi-delete</v-icon>
            <span class="text-caption text-uppercase">Supprimer</span>
          </v-sheet> -->
  
          <v-sheet
            :color="create.save || update.save || add.save?'indigo':'grey'"
            elevation="6"
            class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
            dark
            :max-width="65"
            @click="save()"
            style="cursor: pointer"
          >
            <v-icon  size="32">mdi-content-save</v-icon>
            <span class="text-caption text-uppercase">Garder</span>
          </v-sheet>
        </div>   
      </div>
       <div v-if="vue=='creer' || vue=='modifier' || vue=='voir-attr'">
        <v-simple-table>
            <thead>
              <tr>
                <th class="primary--text">Saison</th>
                <th class="primary--text">Type</th>
                <th class="primary--text">Entraîneur</th>
                <th class="primary--text"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="vue='creer',controlVoir()" v-model="create.saison" :placeholder="'Saison'" :items="saison"></v-select>
                  </v-responsive>
                </td>
                <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="vue='creer',controlVoir()" v-model="create.type" :placeholder="'Type'" :items="[{text:'Tous',value:null},{text:'Enfant',value:1},{text:'Adulte',value:2}]"></v-select>
                  </v-responsive>
                </td>
                <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="controlVoir()" v-model="create.trainer" :placeholder="'Entraîneurs'" :items="trainer"></v-select>
                  </v-responsive>
                </td>
                <td>
                  <v-btn @click="create.save=false,getAttrTrainer()" class="mx-auto" small :disabled="create.saison==''|| create.trainer==''?true:false" color="green">Voir attribution</v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        <div v-if="vue=='creer'">
          
          <v-simple-table v-if="horaire.length">
            <thead>
              <tr>
                <th class="primary--text">ID</th>
                <th class="primary--text">Catégorie</th>
                <th class="primary--text">localisation</th>
                <th class="primary--text">Créneau(x)</th>
                <th class="primary--text">Select</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in horaire" :key="index" @dblclick="vue='modifier',assignUpdate(item), itemUpdate=item, selected=[], trash.save=false">
                <td>
                  {{index + 1}}
                </td>
                <td>
                  {{ capitalization(item.categorie)}}
                </td>
                <td>
                  {{item.location}}
                </td>
                <td>{{item.creneau.length}}</td>
                <td>
                  <v-checkbox
                    :key="item.ref"
                    v-model="selected"
                    :value="JSON.stringify(item.creneau)"
                    @change="controlSelect()"
                  ></v-checkbox>
                  <!-- <v-checkbox
                    :key="item.ref+index"
                    v-model="selected"
                    :value="item.ref"
                    @change="controlSelect()"
                  ></v-checkbox> -->
                </td>
              </tr>
            </tbody>
          </v-simple-table>
       </div>
       <div v-if="vue=='modifier'">
        <div class="primary--text px-5 py-5">{{ capitalization(itemUpdate.categorie) }} / {{ itemUpdate.location }} : </div>
        <v-simple-table>
              <thead>
                <tr>
                  <th class="primary--text">Jour</th>
                  <th class="primary--text">Creneau</th>
                  <th class="primary--text">Description</th>
                  <th class="primary--text">Quota</th>
                  <th class="primary--text">Select</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in itemUpdate.creneau" :key="index">
                  <td>{{item.jour}}</td>
                  <td>{{item.creneau}}</td>
                  <td>{{ item.description.substr(0,300) }}</td>
                  <td>{{item.quotas>0?item.quotas:"aucun"}}</td>
                  <td>
                    <v-checkbox
                    :key="item.ref+index"
                    v-model="selected"
                    :value="item.ref"
                    @change="controlSelect()"
                    ></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
       </div> 
       <div v-if="vue=='voir-attr'" style="width: 100%;">
        <div v-for="(value,i) in lookAttr" :key="i">

          <div class="primary--text px-5 py-5">{{ capitalization(i) }} : </div>
   
        <v-simple-table dense> 
          
              <thead>
                <tr>
                  <th class="primary--text">Jour</th>
                  <th class="primary--text">Creneau</th>
                  <th class="primary--text">Description</th>
                  <th class="primary--text">Quota</th>
                  <th class="primary--text select">Select</th>
                </tr>
              </thead>
              <tbody  v-for="(item,index) in value" :key="index">
                <tr >
                  <td>{{item.jour}}</td>
                  <td>{{item.creneau}}</td>
                  <td>{{ item.description.substr(0,300) }}</td>
                  <td>{{item.quotas>0?item.quotas:"aucun"}}</td>
                  <td class="select">
                    <v-checkbox
                    :key="item.ref+index"
                    v-model="selectedVoirAttr"
                    :value="item.ref"
                    @change="controlSelect()"
                    ></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
       </div> 
       </div>
       <div v-if="vue=='creer2' || vue=='modifier2' || vue=='suivre'">
        <v-simple-table>
            <thead>
              <tr>
                <th class="primary--text">Saison</th>
                <th v-if="vue=='modifier2'" class="primary--text">Type</th>
                <th class="primary--text">Date</th>
                <th  v-if="vue=='suivre' || vue=='creer2'" class="primary--text">
                  
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="vue='creer2',controlVoir()" v-model="create.saison" :placeholder="'Saison'" :items="saison"></v-select>
                  </v-responsive>
                </td>
                <td v-if="vue=='modifier2'">
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="vue='creer2',controlVoir()" v-model="create.type" :placeholder="'Type'" :items="[{text:'Tous',value:null},{text:'Enfant',value:1},{text:'Adulte',value:2}]"></v-select>
                  </v-responsive>
                </td>

                <td>
                  <v-responsive
                    class="mx-0 pt-4"
                   width="150"
                  >
                  <v-menu
         
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedDateFormattedMounth"
            readonly
            v-bind="attrs"
            v-on="on"
            
            style="margin:0 !important;padding: 0 !important;"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          @input="menu2 = false"
          type="month"
          locale="fr-fr"
          style="margin-top: 0 !important;margin-bottom: 0 !important"
        ></v-date-picker>
      </v-menu>
                  </v-responsive>
                </td>
                <td v-if="vue=='suivre' || vue=='creer2'"><v-btn @click="voirSalles()" color="green"
                        >Voir</v-btn></td>
                <!-- <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="controlVoir()" v-model="create.trainer" :placeholder="'Entraîneurs'" :items="trainer"></v-select>
                  </v-responsive>
                </td> -->
                <!-- <td>
                  <v-btn @click="create.save=false,getAttrTrainer()" class="mx-auto" small :disabled="create.saison==''|| create.trainer==''?true:false" color="green">Voir attribution</v-btn>
                </td> -->
              </tr>
            </tbody>
          </v-simple-table>
        <div v-if="vue=='creer2'">
          
          <v-simple-table v-if="arraySalle.length">
            <thead>
              <tr>
                <th class="primary--text">ID</th>
                <th class="primary--text">Salle</th>
                <th class="primary--text">Voir</th>
                <!-- <th class="primary--text">Select</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in arraySalle" :key="index">
                <td>
                  {{index + 1}}
                </td>
                <td>
                  {{ item.nom }}
                </td>
                <td>
                  <v-icon @click="dialog=true,dialogSubTitle=item.nom,getSalleEmargement(item.ref) " >mdi-eye</v-icon>
                  <!-- <v-checkbox
                    :key="item.ref"
                    v-model="selected"
                    :value="item.ref"
                    @change="controlSelect()"
                  ></v-checkbox> -->
                </td>
              </tr>
            </tbody>
          </v-simple-table>
       </div>
       <!-- <div v-if="vue=='modifier2'">
        <div class="primary--text px-5 py-5">{{ capitalization(itemUpdate.categorie) }} / {{ itemUpdate.location }} : </div>
        <v-simple-table>
              <thead>
                <tr>
                  <th class="primary--text">Jour</th>
                  <th class="primary--text">Creneau</th>
                  <th class="primary--text">Description</th>
                  <th class="primary--text">Quota</th>
                  <th class="primary--text">voir</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in itemUpdate.creneau" :key="index">
                  <td>{{item.jour}}</td>
                  <td>{{item.creneau}}</td>
                  <td>{{ item.description.substr(0,300) }}</td>
                  <td>{{item.quotas>0?item.quotas:"aucun"}}</td>
                  <td>
                    <v-icon @click="dialog=true,suivreByDate(item.ref),dialogTitle=`${capitalization(itemUpdate.categorie)} / ${itemUpdate.location}`,dialogSubTitle=`${item.jour} ${item.creneau}`">mdi-eye</v-icon>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
  
       </div>  -->
       <!-- <div v-if="vue=='suivre'" style="width: 100%;">
        <div v-for="(value,i) in lookAttr" :key="i">

          <div class="primary--text px-5 py-5">{{ capitalization(i) }} : </div>
   
        <v-simple-table dense> 
          
              <thead>
                <tr>
                  <th class="primary--text">Jour</th>
                  <th class="primary--text">Creneau</th>
                  <th class="primary--text">Description</th>
                  <th class="primary--text">Quota</th>
                  <th class="primary--text select">Select</th>
                </tr>
              </thead>
              <tbody  v-for="(item,index) in value" :key="index">
                <tr >
                  <td>{{item.jour}}</td>
                  <td>{{item.creneau}}</td>
                  <td>{{ item.description.substr(0,300) }}</td>
                  <td>{{item.quotas>0?item.quotas:"aucun"}}</td>
                  <td class="select">
                    <v-checkbox
                    :key="item.ref+index"
                    v-model="selectedVoirAttr"
                    :value="item.ref"
                    @change="controlSelect()"
                    ></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
       </div>  -->
       </div>
    </div>

  </v-col>
  </v-row>
  <!-- Dialog -->
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      ref="dialogPDF"
      persistent
      min-width="320px"
      height="100%"
      style="width:100% !important;"
    >
      <v-card  style="width:100% !important;">
        <v-card-title class="text-start" style="padding: 6px 12px;font-size:14px;">Emargement: {{ capitalization(MomentLongMounth(date)) }}</v-card-title>
        <v-card-subtitle class="text-start" style="padding: 6px 12px;font-size:12px;">{{ dialogSubTitle }}</v-card-subtitle>
        <!-- <v-card-subtitle class="text-start" style="margin:0;padding: 0 12px;font-size:12px;">
          {{ MomentLongMounth(date) }}
        </v-card-subtitle>
        <v-card-subtitle class="text-start" style="padding: 6px 12px ;font-size:12px;">{{  `${dialogSelected.length}/${adherentEmargement.length}` }} présents</v-card-subtitle> -->
        <v-divider></v-divider>
        <v-progress-linear
            :active="!loading"
            :indeterminate="!loading"
            absolute
            top
            color="primary"
          ></v-progress-linear>
        <div  style="background-color: #ffffff;" ref="grid">
          
          <EmargementDataGrid v-if="loading" :dataEmargement="dataEmargement" :salle="dialogSubTitle" :date="date"></EmargementDataGrid>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            v-if="loading"
            @click="imprimerEmargement()"
          >
            Imprimer
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialogSelected=[],dialog = false, dataEmargement = [], loading = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <!-- Dialog -->
</v-container>
  </template>
  <script>

  import moment from 'moment'
  import EmargementDataGrid from '@/views/dashboard/component/EmargementDataGrid.vue'
  import Inscriptions from "@/services/Inscription.js"
  import Categories from "@/services/Categorie.js"
  import Horaires from "@/services/Horaire.js"
  import Horaire_days from "@/services/Horaire_day.js"
  import Salles from "@/services/Salle.js"
  import Users from "@/services/User.js"
  import Emargements from "@/services/Emargement.js"
  import html2pdf from "html2pdf.js";
  import Vue from "vue";
  export default {
    name: "Emargement",
    components: {
      EmargementDataGrid
  },
    data: () => ({
      loading:false,
      window:null,
      dialog:false,
      dialogSelected:[],
      dialogTitle:'',
      dialogSubTitle:'',
      adherentNumber:0,
      menu2: false,
      date: new Date().toISOString().substring(0, 7),
      // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0,10), // date: moment().format("DD/MM/YYYY"),
      adherentEmargement:[],
      dataEmargement:[],

      // Horaire
      saison:[],
      categorie:[],
      salle:[],
      arraySalle:[],
      horaire:[],
      trainer:[],
      lookAttr:[],
      selectedVoirAttr:[],
      selectedVoirAttrCopy:[],
      // horaireFilter:[],
      arrayInscription:[],
      arrayTrainer:[],
      // Horaire
      
      selected:[],
      trash:{
        save:false
      },    
      
      itemUpdate:{},
  
      add:{
        save:false,
        ref:null,
        creneau:[
        {jour:"",
        time2:null,
        time:null,
        description2:"",
        quota:"",
        modal2:false,
        modal:false,},
        {jour:"",
        time2:null,
        time:null,
        description2:"",
        quota:"",
        modal2:false,
        modal:false,},
        {jour:"",
        time2:null,
        time:null,
        description2:"",
        quota:"",
        modal2:false,
        modal:false,},
        {jour:"",
        time2:null,
        time:null,
        description2:"",
        quota:"",
        modal2:false,
        modal:false,},
        ],
      },
  
      update:
      {
      save:false,
      ref:null,
      saison:"",
      type:null,
      categorie:"",
      description:"",
      localisation:"",
      adresse:"",
      switchReadOnly:false,
      
      creneau:[
      {jour:"",
      time2:null,
      time:null,
      description2:"",
      quota:"",
      modal2:false,
      modal:false,},
      ],
      },
  
      voir:{
        saison:"",
        type:null,
        trainer:""
      },
  
      create:
      {
      save:false,
      ref:null,
      saison:"",
      type:null,
      categorie:"",
      trainer:"",
      // description:"",
      localisation:"",
      // adresse:"",
      switchReadOnly:false,
      
      creneau:[
      {jour:"",
      time2:null,
      time:null,
      description2:"",
      quota:"",
      modal2:false,
      modal:false,},
      {jour:"",
      time2:null,
      time:null,
      description2:"",
      quota:"",
      modal2:false,
      modal:false,},
      {jour:"",
      time2:null,
      time:null,
      description2:"",
      quota:"",
      modal2:false,
      modal:false,},
      {jour:"",
      time2:null,
      time:null,
      description2:"",
      quota:"",
      modal2:false,
      modal:false,},
      ],
      },
      arrayInscription:[],
      vue: "creer",
    }),
    mounted() {
      this.getSaison()
      this.getTrainersSelect()
      if (typeof window !== 'undefined') {
      this.window = window;
      console.log('Window:', this.window);
    }
    },
    watch: {
      
     
   
    
      // 'create.type': {
      //   handler(newValue, oldValue) {
      //     console.log("newValue type",newValue)
      //     if(this.vue=='voir' && newValue){
      //       this.create.categorie=""
      //       this.controlSave()
      //     }
      //   },
      //   deep: true
      // },
      // 'create.saison': {
      //   handler(newValue, oldValue) {
      //     console.log("newValue type",newValue)
      //     if(this.vue=='voir' && newValue){
      //       this.create.categorie=""
      //       this.controlSave()
      //     }
      //   },
      //   deep: true
      // }
    },
    computed: {
      computedDateFormattedMounth () {
        return this.MomentLongMounth(this.date)
      },
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },
    methods:{
      async imprimerEmargement(){
            const ComponentClass = Vue.extend(EmargementDataGrid);
      const componentInstance = new ComponentClass({propsData: {
        dataEmargement: this.dataEmargement,
        date:this.date,
        salle:this.dialogSubTitle
  }}).$mount();
  // this.$nextTick(
  let width = ""
  let height = ""
    Vue.nextTick(
        ()=>{

          const elements = this.$refs.grid;
          // const elements = componentInstance.$el;
        //  console.log("elements",elements)  
const computedStyles = this.window.getComputedStyle(elements);
// console.log("computedStyles",computedStyles)
width = computedStyles.width.replace("px", "")
height = computedStyles.height.replace("px", "")
// console.log('Width (calculated):', computedStyles.width.replace("px", ""));
// console.log('Height (calculated):', computedStyles.height.replace("px", ""));
        
this.htmlString = componentInstance.$el;
      
            const element = this.htmlString;
            const opt = {
                margin: 0,
                filename: "carte-emargement.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 1 },
                // html2canvas: { scale: 1 },
                // html2canvas: { useCORS: true },
                jsPDF: { unit: "pt", format: [parseInt(width)*0.75, parseInt(height)*0.75],orientation: "landscape" },
                // jsPDF: { unit: "in", format: "a3", orientation: "landscape" },
            };

            html2pdf().set(opt).from(element).save();
            // html2pdf(element, opt);
})
    

      // this.htmlString = this.$refs.content;
//       this.htmlString = componentInstance.$el;
//       // this.htmlString = componentInstance.$refs.content;
//       // const content = componentInstance
//       // const content = this.$refs.dialogPDF.$el
// //       console.log("content",componentInstance)
// //       const height = componentInstance.offsetHeight;
// // const width = componentInstance.offsetWidth;
//       // console.log("width, height",width, height)
//             const element = this.htmlString;
//             const opt = {
//                 margin: 0,
//                 filename: "carte-emargement.pdf",
//                 image: { type: "jpeg", quality: 0.98 },
//                 html2canvas: { scale: 2 },
//                 jsPDF: { unit: "px", format: [width, height], orientation: "landscape" },
//                 // jsPDF: { unit: "in", format: "a3", orientation: "landscape" },
//             };

//             html2pdf(element, opt);
        },
      async getSalleEmargement(ref_salle){
        try {
          this. dataEmargement = await Emargements.suivreEmargementByDateSalle({
            ref_salle:ref_salle,
            ref_inscription:this.create.saison,
            date:moment(this.date).format("YYYY-MM"),
          })
        } catch (error) {
          console.log(error)
        }finally{
          if(this.dataEmargement.length){this.loading=true}
        }
       
      },
      async suivreByDate(ref){
        const response = await Emargements.suivreEmargementByDate(
          {
            ref_inscription: this.create.saison,
            date:moment(this.date).format("YYYY-MM-DD"),
            ref_creneau:ref
          }
        )
        this.adherentEmargement = response
        response.map((el)=>{if(el.presence){this.dialogSelected.push(el.ref)}})
        // console.log("response==>",response)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      arraysEqual(arr1, arr2) {
  // Vérifier si les deux tableaux ont la même longueur
  if (arr1.length !== arr2.length) return false;

  // Trier les tableaux et comparer chaque élément
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return sortedArr1.every((value, index) => value === sortedArr2[index]);
},
      async getAttrTrainer(){
        this.selectedVoirAttr =[]
        this.selectedVoirAttrCopy =[]
        const response = await Emargements.getAttr({
          ref_user:this.create.trainer,
          ref_inscription: this.create.saison,
        })
        console.log("response getAttrTrainers",response)
        this.lookAttr = response
        this.vue="voir-attr"
        Object.values(response).map(el=>el.map(e=>this.selectedVoirAttrCopy.push(e.ref)))
        Object.values(response).map(el=>el.map(e=>this.selectedVoirAttr.push(e.ref)))
        console.log("this.selectedVoirAttr",this.selectedVoirAttr)
      },
      init(){
        this.horaire = []
        this.arraySalle = []
        Object.assign(this.$data.create, this.$options.data().create);    
        Object.assign(this.$data.update, this.$options.data().update);    
        Object.assign(this.$data.voir, this.$options.data().voir);
        Object.assign(this.$data.add, this.$options.data().add);
        Object.assign(this.$data.trash, this.$options.data().trash);
        this.itemUpdate = {} 
        this.selected = []
   
      },
      async getSalleByInscription(options){
        let arraySalle = await Salles.getByInscription(options)
        arraySalle.forEach(el=>{
          this.salle.push({text:el.nom,value:el.ref})
        })
      },
  
      getInscriptionByID(id){
        let findEl = this.arrayInscription.find(el=>el.id==id)
        console.log("findEl",findEl)
        return findEl.ref
      },
  
      assignUpdate(item){
        console.log("item",item)
        if(this.vue=="modifier"){
            let options = {
              type: item.type,
              ref_inscription: item.ref_inscription
            }
        this.getCategorieByTypeInscription(options)
        this.getSalleByInscription(options)
  
        console.log("saison ref ",this.getInscriptionByID(item.id_inscription))
        this.update.saison=item.ref_inscription
        this.update.ref=item.ref
        this.update.type=item.type
        this.update.categorie=item.categorie_ref
        this.update.description=item.description
        this.update.localisation=item.ref_location
        this.update.adresse=item.adresse
        this.update.switchReadOnly=item.readonly
  
        this.add.ref=item.ref
        }
        
        if(this.vue=="modifier-2"){
          this.update.ref=item.ref
          this.update.creneau[0].jour=item.jour
          this.update.creneau[0].time=item.creneau.split("/")[0]
          this.update.creneau[0].time2=item.creneau.split("/")[1]
          this.update.creneau[0].description2=item.description
          this.update.creneau[0].quota=item.quotas
        }
  
      },
  
      controlSelect(){
        if(this.selected.length && (this.vue=="creer" || this.vue=="modifier")){
          this.trash.save = true
        }else{
          this.trash.save = false
        }

        if((this.vue=='creer' || this.vue=="modifier") && this.selected.length && this.create.trainer.length){
          console.log("this.selected",this.selected)
          this.create.save=true
          }else
        
          if((this.vue=='voir-attr') && !this.arraysEqual(this.selectedVoirAttr,this.selectedVoirAttrCopy) ){
          this.create.save=true
          }else{
            this.create.save=false
          }

      },
      
     async supprimer(){
        console.log("this.selected",this.selected)
        if(this.trash.save && this.vue=="creer"){
          let deleteSelected = 
          await Horaires.delete(
            {
              array_ref: this.selected,
            }
          )
          console.log("deleteSelected save",deleteSelected)
          this.trash.save = !deleteSelected
          this.selected = []
          let options = {ref_inscription:this.voir.saison, type:this.voir.type}
          this.getHoraire(options)
        }
  
        if(this.trash.save && this.vue=="modifier"){
          let deleteSelected = 
          await Horaire_days.delete(
            {
              array_ref: this.selected,
            }
          )
          console.log("deleteSelected save",deleteSelected)
          this.trash.save = !deleteSelected
          this.itemUpdate.creneau = JSON.parse(JSON.stringify(this.itemUpdate.creneau)).filter(item=>!this.selected.includes(item.ref))
          this.selected = []
        }      
      },    
  
      async getHoraire(options){
        let arrayHoraire = await Horaires.getBySaison(options)
        console.log("arrayHoraires.data",arrayHoraire)
        this.horaire = arrayHoraire
      },
  
      async getCategorieByTypeInscription(options){
        let arrayCategorie = await Categories.getByTypeAndIscription(options)
        console.log("arrayInscription.data",arrayCategorie)
        this.categorie = []
        arrayCategorie.forEach(element => {
          this.categorie.push({text:`${this.capitalization(element.niveau)} (${element.startAge}${element.endAge?'/'+element.endAge+' ans':''})`,value:element.ref})
        });
      },
  
      capitalization(string){
        return string[0].toUpperCase() + string.slice(1);
      },
      async getSaison(){
        this.arrayInscription = await Inscriptions.get()
        console.log("arrayInscription.data",this.arrayInscription)
        this.arrayInscription.forEach(element => {
          this.saison.push({text:element.saison,value:element.ref})
          if(element.actif){
            this.create.saison = element.ref
            this.controlVoir()
          }
        });
      },
      async getTrainersSelect(){
        this.arrayTrainer = await Users.getTrainers()
        console.log("arrayTrainer",this.arrayTrainer)
        this.arrayTrainer.forEach(element => {
          this.trainer.push({text:`${element.prenom} ${element.nom}`,value:element.ref_user})
        });
      },
      async save(){
        console.log("save enter")
        if(this.create.save){
          if(this.vue=='voir-attr'){
            let options = {
            typeAttr:"update",
            ref_user:this.create.trainer,
            ref_inscription:this.create.saison,
            ref_horaire_day:JSON.stringify(this.selectedVoirAttr) 
            }
            const response = await Emargements.attribuer(options)
          

          if(response){
            const responseAttr = await Emargements.getAttr({
              ref_user:this.create.trainer,
              ref_inscription: this.create.saison,
            })
            console.log("response getAttrTrainers update",responseAttr)
            this.lookAttr = responseAttr
            this.create.save= false
          }}
        }

        if( this.create.save){
          if(this.vue=='creer'){
            console.log("this.selected test",this.selected)
            let ref_horaire_day = []
            this.selected.map(el=>{JSON.parse(el).map(e=>ref_horaire_day.push(e.ref))})
            console.log("ref_horaire_day",ref_horaire_day)
            console.log("this.create.trainer",this.create.trainer)
            let options = {
            typeAttr:"create",
            ref_user:this.create.trainer,
            ref_inscription:this.create.saison,
            ref_horaire_day:JSON.stringify(ref_horaire_day) 
          }

          
          const response = await Emargements.attribuer(options)
          if(response){
                
               
              
                Object.assign(this.$data.create, this.$options.data().create);
              this.selected = []
              this.horaire = []
              this.create.save = false
            }
          }
          if(this.vue=='modifier'){
            let options = {
            typeAttr:"create",
            ref_user:this.create.trainer,
            ref_inscription:this.create.saison,
            ref_horaire_day:JSON.stringify(this.selected) 
          }
          const response = await Emargements.attribuer(options)
          if(response){
                
               
              
              Object.assign(this.$data.create, this.$options.data().create);
              this.selected = []
              this.horaire = []
              // this.itemUpdate.creneau=[]
              this.create.save = false
              this.vue = "creer"
            }
          }
          
        }

        if(this.vue=='modifier-2' && this.update.save){
          console.log("save 4",this.update)
          let putHoraireDay = 
                  await Horaire_days.put(
            {
                  description: this.update.creneau[0].description2,
                  creneau: this.update.creneau[0].time+"/"+this.update.creneau[0].time2,
                  jour: this.update.creneau[0].jour,
                  ref: this.update.ref,
                  quotas: this.update.creneau[0].quota
            }
          )
          console.log("putHoraireDay save",putHoraireDay)
          this.update.save = !putHoraireDay
        }
        
        if(this.vue=='modifier' && this.update.save){
          console.log("save 1",this.update)
          let putHoraire = 
                  await Horaires.put(
            {
                  location: this.update.localisation,
                  readonly: this.update.switchReadOnly,
                  ref: this.update.ref,
                  categorie: this.update.categorie,
            }
          )
          console.log("putHoraire save",putHoraire)
          this.update.save = !putHoraire
          console.log("this.update.save",this.update.save)
        }
        
        if(this.vue=='voir' && this.create.save){
          console.log("save 2")
          let postHoraire = 
          await Horaires.post(
            {
  
                  location: this.create.localisation,
                 
                  readonly: this.create.switchReadOnly,
                  type: this.create.type,
                  ref: this.create.saison,
                  categorie: this.create.categorie,
                  
                  creneau: this.create.creneau
               
            }
          )
          if(postHoraire){
                
               
              
                Object.assign(this.$data.create, this.$options.data().create);
          }
        }
  
        // if(this.vue=='ajouter' && this.add.save){
        //   console.log("save 3")
        //   let postHoraireDay = 
        //   await Horaire_days.post(
        //     { 
        //           ref:this.add.ref,
        //           creneau: this.add.creneau
                  
        //     }
        //   )
        //   if(postHoraireDay){Object.assign(this.$data.add, this.$options.data().add);}
    
        // }
      },
      async voirSalles(){
        if(this.create.saison!=""){
          this.vue="creer2"
          this.trash.save = false 
          this.create.save=false       
          this.selected = []
          let options = {ref_inscription:this.create.saison}
          this.arraySalle = await Salles.getByInscription(options)
        }    
      },
      async controlVoir(){
        console.log("test voir")
        if(this.vue=='creer' && this.create.saison!=""){
          this.trash.save = false 
          this.create.save=false       
          this.selected = []
          let options = {ref_inscription:this.create.saison, type:this.create.type}
          this.getHoraire(options)
        }    
        // if(this.vue=='creer2' && this.create.saison!=""){
        //   this.trash.save = false 
        //   this.create.save=false       
        //   this.selected = []
        //   let options = {ref_inscription:this.create.saison}
        //   this.arraySalle = await Salles.getByInscription(options)
        // }    
      },
      controlSave(){
        console.log("test")
        console.log("$refs",this.$refs)
        if(
          this.vue=='ajouter' &&
              (this.add.creneau[0].jour!=""
              && this.add.creneau[0].time2!=null
              && this.add.creneau[0].time!=null)
              
              || (this.add.creneau[1].jour!=""
              && this.add.creneau[1].time2!=null
              && this.add.creneau[1].time!=null)
              
              || (this.add.creneau[2].jour!=""
              && this.add.creneau[2].time2!=null
              && this.add.creneau[2].time!=null)
              
              || (this.add.creneau[3].jour!=""
              && this.add.creneau[3].time2!=null
              && this.add.creneau[3].time!=null)
        ){
          console.log("this.saisonStart 1",this.create)
          this.add.save=true
        }else{
          console.log("this.saisonStart 2",this.create)
          this.add.save=false
        }
  
        if(this.vue=='voir' && this.create.saison!=""){
          let options = {ref_inscription:this.create.saison,type:this.create.type}
          if(this.create.type!=null){
            this.getCategorieByTypeInscription(options)
          }
          this.getSalleByInscription(options)
        }

       if(
          this.vue=='voir' 
              && this.create.saison!=""
              && this.create.type!=null
              && this.create.categorie!=""
              && this.create.localisation!=""
  
              && (this.create.creneau[0].jour!=""
              && this.create.creneau[0].time2!=null
              && this.create.creneau[0].time!=null)
              
              || (this.create.creneau[1].jour!=""
              && this.create.creneau[1].time2!=null
              && this.create.creneau[1].time!=null)
              
              || (this.create.creneau[2].jour!=""
              && this.create.creneau[2].time2!=null
              && this.create.creneau[2].time!=null)
              
              || (this.create.creneau[3].jour!=""
              && this.create.creneau[3].time2!=null
              && this.create.creneau[3].time!=null)
        ){
          console.log("this.saisonStart 1",this.create)
          this.create.save=true
        }else{
          console.log("this.saisonStart 2",this.create)
          this.create.save=false
        }
        
        if(
          this.vue=='modifier' &&
              (this.update.saison!=this.itemUpdate.ref_inscription && this.itemUpdate.ref_inscription!=undefined)
              ||( this.update.type!=this.itemUpdate.type && this.itemUpdate.type!=undefined)
              || (this.update.categorie!=this.itemUpdate.categorie_ref &&  this.itemUpdate.categorie_ref!=undefined)
              || (this.update.localisation!=this.itemUpdate.ref_location && this.itemUpdate.ref_location!=undefined)
              || (this.update.switchReadOnly!=this.itemUpdate.readonly && this.itemUpdate.readonly!=undefined)
        ){
          console.log("this.saisonStart 1",this.update)
          console.log("this.saisonStart item 1",this.itemUpdate)
          this.update.save=true
        }else{
          console.log("this.saisonStart 2",this.update)
          this.update.save=false
        }
        
        if(this.vue=='modifier-2'){
        if(
          (this.update.creneau[0].jour!=this.itemUpdate.jour && this.itemUpdate.jour!=undefined)
          || (this.update.creneau[0].time!=this.itemUpdate.creneau.split("/")[0] && this.itemUpdate.creneau!=undefined)
          || (this.update.creneau[0].time2!=this.itemUpdate.creneau.split("/")[1] && this.itemUpdate.creneau!=undefined)
          || (this.update.creneau[0].description2!=this.itemUpdate.description && this.itemUpdate.description!=undefined)
          || (this.update.creneau[0].quota!=this.itemUpdate.quotas && this.itemUpdate.quotas!=undefined)
        ){
          console.log("this.saisonStart 1",this.update)
          this.update.save=true
        }else{
          console.log("this.saisonStart 2",this.update)
          this.update.save=false
        }
        }
      },
      Moment(date){
        return moment(date).format("DD/MM/YYYY")
      },
      MomentLongMounth(date){
        return moment(date,'YYYY-MM-DD','fr').format("MMMM")
      },
      async getInscription(){
        this.arrayInscription = await Inscriptions.get()
      }
    }
  };
  </script>
  <style>
.v-date-picker-table--month table{
  width: auto !important;
  text-align: center !important;
  justify-content: center !important;
}
.v-date-picker-table--month table td{
  width: auto !important;
  text-align: center !important;
  justify-content: center !important;
}

.v-date-picker-table--month table td .v-btn {
    /* width: auto; */
    max-width: 40px !important;
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
  margin-right:5px !important;
  margin-left:5px !important;
}
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,td {
    width: 250px !important;
  }

  .v-data-table > .v-data-table__wrapper > table > thead > tr > th.select,td.select {
    text-align: right !important;
  }
 
  /* .v-data-table > .v-data-table__wrapper > table > tbody > tr > td.select{
    text-align: right !important;
} */
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td.select .v-input__slot{
    justify-content:end !important;
}
  </style>
  